import { render, staticRenderFns } from "./TabInventoryBins.vue?vue&type=template&id=edc00112"
import script from "./TabInventoryBins.vue?vue&type=script&lang=ts"
export * from "./TabInventoryBins.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports